import { render, staticRenderFns } from "./ESituacaoPlano.vue?vue&type=template&id=2c9b65ec"
import script from "./ESituacaoPlano.vue?vue&type=script&lang=js"
export * from "./ESituacaoPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports